import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAlert } from '../../redux/dashboard/actions';
import icons from '../../assets/icons';
import components from '../../components';
import API from '../../services/api';
import utils from '../../utils';
import { getSelectedProject } from '../../redux/projects/actions';

const { CustomInput, IconButton, CustomButton } = components;

const Mapping = ({ mapping, selectedIntegration, asset, credentialName, loadCredentials, loadMappings }) => {
  const [active, setActive] = useState(false);
  const [values, setValues] = useState(mapping.metadata);
  const [displayName, setDisplayName] = useState(mapping.displayName ? mapping.displayName : '');

  const project = useSelector(getSelectedProject);
  const dispatch = useDispatch();

  const updateMapping = () => {
    API.updateMapping(project.id, mapping.id, { ...mapping, metadata: values, displayName }, [
      'metadata',
      'displayName'
    ])
      .then(() => {
        dispatch(setAlert(utils.generateAlert('Mapping updated successfuly!', 'success')));
        loadCredentials();
        loadMappings();
      })
      .catch(err => {
        console.error(err);
        dispatch(setAlert(utils.generateAlert('Could not update this mapping. Try again later.', 'error')));
      });
  };

  const updateForm = (field, val) => {
    setValues({ ...values, [field]: val });
  };

  // Prevent breaking application if mapping field is missing
  if (!mapping) return null;

  return (
    <div className="account-item">
      <div className={`account-accordion-item ${active ? 'active' : ''}`}>
        <div
          className="account-title"
          onClick={() => {
            setActive(!active);
          }}
        >
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="d-flex align-items-center">
              <img className="user-icon" src={icons.media} alt="asset" />
              <h3>{asset?.displayName || asset?.id}</h3>
            </div>
            <div className="d-flex align-items-center">
              <img className="user-icon" src={icons.userDark} alt="account" />
              <h3>{credentialName}</h3>
            </div>
            <div className="d-flex align-items-center">
              <img className="media-icon" src={icons.media} alt="account" />
              <h3>{mapping.playerId}</h3>
            </div>
            <img className="arrow-icon" src={icons.angleRight} alt="arrow" />
          </div>
        </div>

        <div className="account-fields">
          <div className="form-row">
            <div className="col" key="asset-id">
              <div className="form-group">
                <label>Asset ID</label>
                <CustomInput
                  id={`asset-id-${asset?.id}`}
                  type="text"
                  value={asset?.id || ''}
                  isEditable={false}
                  onChange={() => {}}
                />
              </div>
              <div className="form-group">
                <label>Mapping Name</label>
                <CustomInput
                  id={`mapping-name-${mapping?.id}`}
                  type="text"
                  value={displayName}
                  isEditable={true}
                  onChange={e => setDisplayName(e.target.value)}
                />
              </div>
            </div>
            {selectedIntegration.mappingMetadataFields.map(field => {
              return (
                <div className="col" key={field}>
                  <div className="form-group">
                    <label>{field}</label>
                    <CustomInput
                      id={`${mapping.id}-${field}`}
                      type="text"
                      value={values[field]}
                      isEditable
                      onChange={e => {
                        updateForm(field, e.target.value);
                      }}
                      autoFocus
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="form-row justify-content-end">
            <CustomButton classes="btn-primary" title="Update" handleClick={updateMapping} />
          </div>
        </div>
      </div>
      <div className="account-buttons">
        <IconButton
          id={`btn-delete-${mapping.id}`}
          btnClasses="account-button"
          tooltip="Remove Account"
          icon="del"
          onPress={() => {
            API.deleteMapping(project.id, mapping.id)
              .then(() => {
                loadCredentials();
                loadMappings();
                dispatch(setAlert(utils.generateAlert('Mapping deleted successfuly!', 'success')));
              })
              .catch(err => {
                dispatch(setAlert(utils.generateAlert('Could not delete this mapping. Try again later.', 'error')));
                console.error(err);
              });
          }}
        />
      </div>
    </div>
  );
};

export default Mapping;
